import { computed, inject, Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";
import { ModalDataInterface } from "../interfaces/modal-interface";
import { TranslocoService } from "@jsverse/transloco";

export type ErrorModalType = "primary" | "secondary";

export interface ErrorModalState {
  isOpen: boolean;
  title: string;
  text: string;
  buttonText: string;
  type: ErrorModalType;
  showClose: boolean;
  image: string;
}

const DEFAULT_ERROR_MODAL_STATE: ErrorModalState = {
  isOpen: false,
  title: "An error has occurred",
  text: "The site content is not accessible to you at the moment. Please contact an administrator.",
  buttonText: "Close",
  type: "primary",
  showClose: true,
  image: "",
};

@Injectable({
  providedIn: "root",
})
export class ErrorModalService {
  private readonly router = inject(Router);
  private readonly translocoService = inject(TranslocoService);
  
  private readonly _state = signal<ErrorModalState>(DEFAULT_ERROR_MODAL_STATE);

  readonly state = computed(() => this._state());
  readonly isOpen = computed(() => this._state().isOpen);

  open(overrides?: Partial<Omit<ErrorModalState, "isOpen">>): void {
    this._state.set({
      ...DEFAULT_ERROR_MODAL_STATE,
      ...overrides,
      isOpen: true,
    });
  }

  close(): void {
    this._state.update((current) => ({ ...current, isOpen: false }));
    this.router.navigate(["/"]);
  }

  openGenericHttpError(): void {
    this.open();
  }

  shouldOpenErrorModal(error: unknown): boolean {
    return true;
  }

  openErrorModal(): void {
    this.open({
      title: this.translocoService.translate("components.errorModal.title"),
      text: this.translocoService.translate("components.errorModal.text"),
      buttonText: this.translocoService.translate(
        "components.errorModal.button"
      ),
      type: "primary",
      showClose: true,
      image: "",
    } as ModalDataInterface);
  }
}
